/*
 * @Author:
 * @LastEditTime: 2022-07-18 14:20:42
 * @Description:
 */
import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class roamTrace {
  //  新增路径
  static async saveRoamTrace(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/RoamTrace', payload))
    return Callback(err, res)
  }
  //   查询路径列表
  static async getRoamTraceList(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/RoamTrace/?${qs.stringify(payload)}`))
    return Callback(err, res)
  }
  //   修改路径
  static async modifyRoamTrace(payload) {
    const [err, res] = await To(wizStandardInstance.put('/api/RoamTrace', payload))
    return Callback(err, res)
  }
  //   删除路径
  static async delRoamTrace(payload) {
    const [err, res] = await To(wizStandardInstance.delete('/api/RoamTrace', { data: payload }))
    return Callback(err, res)
  }
  //   查询路径详情
  static async getRoamTraceDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/RoamTrace/roam_trace_detail/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  //   更新路径详情
  static async updateRoamTraceDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(
        `/api/RoamTrace/${payload.roam_trace_id}/roam_trace_detail`,
        payload.detail
      ),
      payload.detail
    )
    return Callback(err, res)
  }
  // 批量修改序号
  static async changeRoamTraceSeq(payload) {
    const [err, res] = await To(wizStandardInstance.put('/api/roamtrace/seq/batch', payload))
    return Callback(err, res)
  }
}
